module.exports = __webpack_public_path__ + "img/swiper-item1-6.f75aa706.png";